/**
 * Loads a curated list from URL param and merges POI IDs into bookmarks (once).
 */

import { useRef, useEffect } from "react";
import { useLoadCuratedList } from "../useCuratedLists";
import { analytics } from "../../lib/analytics";

interface UseCuratedListLoaderOptions {
  orgSlug: string;
  mapSlug: string;
  listSlug: string | undefined;
  onLoadPOIs: (poiIds: string[], listName: string, description: string | null) => void;
  enabled: boolean;
}

export function useCuratedListLoader({
  orgSlug,
  mapSlug,
  listSlug,
  onLoadPOIs,
  enabled,
}: UseCuratedListLoaderOptions) {
  const hasLoaded = useRef(false);

  const { data: list } = useLoadCuratedList(
    enabled ? orgSlug : undefined,
    enabled ? mapSlug : undefined,
    enabled ? listSlug : undefined
  );

  useEffect(() => {
    if (!list || hasLoaded.current) return;
    hasLoaded.current = true;

    const poiIds = list.items.map((item) => item.poiId);
    if (poiIds.length === 0) return;

    onLoadPOIs(poiIds, list.name, list.description);

    analytics.curatedListLoaded({
      list_slug: list.slug,
      list_name: list.name,
      poi_count: poiIds.length,
      source: "url",
    });
  }, [list, onLoadPOIs]);
}
